<template>
  <UiDropdown v-if="languages?.length" class="header-currency-dropdown">
    <template #activator="{ props }">
      <AppHeaderActionWrapper
        v-if="selectedLanguageName"
        v-bind="props"
        data-test="header-currency-button"
      >
        <div class="d-flex align-center">
          <UiText variant="body-4" color="text-on-dark">
            {{ selectedLanguageName }}
          </UiText>

          <UiIcon icon="$chevronDown" class="ml-2" />
        </div>
      </AppHeaderActionWrapper>
    </template>
    <UiDropdownItem
      v-for="language in languages"
      :key="language.id"
      :value="language.id"
      :is-active="language.id === selectedLanguage"
      data-test="header-currency-item"
      class="currency-item"
      @click="changeLanguage(language.id)"
    >
      {{ language.name }}
    </UiDropdownItem>
  </UiDropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { UiDropdown, UiDropdownItem, UiText, UiIcon } from '~/ui';
import AppHeaderActionWrapper from './AppHeaderActionWrapper.vue';
import { usePartnershipLanguageStore } from '~/domains/partnership';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const { setSelectedLanguage } = usePartnershipLanguageStore();
const { languages, selectedLanguage } = storeToRefs(
  usePartnershipLanguageStore(),
);

const selectedLanguageName = computed(() => {
  return (
    languages.value.find((language) => language.id === selectedLanguage.value)
      ?.name ?? selectedLanguage.value
  );
});

const changeLanguage = (language: string): void => {
  setSelectedLanguage(language);

  if (route.query.lang !== undefined) {
    const { lang, ...queryWithoutLang } = route.query;
    void router.replace({
      path: route.path,
      query: queryWithoutLang,
    });
  }
};
</script>

<style lang="scss" scoped>
.currency-item {
  :deep(.v-list-item) {
    cursor: pointer;
    position: relative;
    z-index: 1;
  }
}
</style>
